const STORAGE_PREFIX = "cxt:h5:";

function createStorage() {
  return {
    getStorageSync(key) {
      try {
        const raw = window.localStorage.getItem(STORAGE_PREFIX + key);
        return raw == null ? "" : JSON.parse(raw);
      } catch (err) {
        return "";
      }
    },
    setStorageSync(key, value) {
      try {
        window.localStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(value));
      } catch (err) {
      }
    },
    removeStorageSync(key) {
      try {
        window.localStorage.removeItem(STORAGE_PREFIX + key);
      } catch (err) {
      }
    },
  };
}

function ensureToastRoot() {
  let root = document.getElementById("wx-h5-toast-root");
  if (root) {
    return root;
  }

  root = document.createElement("div");
  root.id = "wx-h5-toast-root";
  root.style.position = "fixed";
  root.style.left = "50%";
  root.style.bottom = "18%";
  root.style.transform = "translateX(-50%)";
  root.style.zIndex = "9999";
  root.style.pointerEvents = "none";
  document.body.appendChild(root);
  return root;
}

function showToast(options = {}) {
  const { title = "", icon = "none", duration = 1800 } = options;
  const root = ensureToastRoot();
  root.innerHTML = "";

  const toast = document.createElement("div");
  toast.textContent = title || (icon === "success" ? "操作成功" : "");
  toast.style.maxWidth = "72vw";
  toast.style.padding = "10px 14px";
  toast.style.borderRadius = "10px";
  toast.style.background = "rgba(0,0,0,0.78)";
  toast.style.color = "#fff";
  toast.style.fontSize = "14px";
  toast.style.lineHeight = "1.4";
  toast.style.textAlign = "center";
  toast.style.boxShadow = "0 8px 30px rgba(0,0,0,0.18)";
  root.appendChild(toast);

  window.setTimeout(() => {
    if (toast.parentNode) {
      toast.parentNode.removeChild(toast);
    }
  }, duration);
}

function ensureLoadingRoot() {
  let root = document.getElementById("wx-h5-loading-root");
  if (root) {
    return root;
  }

  root = document.createElement("div");
  root.id = "wx-h5-loading-root";
  root.style.position = "fixed";
  root.style.inset = "0";
  root.style.display = "none";
  root.style.alignItems = "center";
  root.style.justifyContent = "center";
  root.style.background = "rgba(0,0,0,0.18)";
  root.style.zIndex = "9998";
  root.innerHTML = '<div style="min-width:96px;padding:14px 16px;border-radius:12px;background:rgba(0,0,0,0.78);color:#fff;font-size:14px;text-align:center">加载中...</div>';
  document.body.appendChild(root);
  return root;
}

function showLoading(options = {}) {
  const root = ensureLoadingRoot();
  const box = root.firstChild;
  if (box && options.title) {
    box.textContent = options.title;
  }
  root.style.display = "flex";
}

function hideLoading() {
  const root = document.getElementById("wx-h5-loading-root");
  if (root) {
    root.style.display = "none";
  }
}

function showModal(options = {}) {
  const {
    title = "提示",
    content = "",
    success,
    showCancel = true,
  } = options;
  const confirmed = showCancel
    ? window.confirm([title, content].filter(Boolean).join("\n\n"))
    : (window.alert([title, content].filter(Boolean).join("\n\n")), true);
  if (typeof success === "function") {
    success({ confirm: confirmed, cancel: !confirmed });
  }
}

function showActionSheet(options = {}) {
  const { itemList = [], success, fail } = options;
  if (!itemList.length) {
    if (typeof fail === "function") {
      fail({ errMsg: "showActionSheet:fail empty itemList" });
    }
    return;
  }

  const promptText = itemList.map((item, index) => `${index + 1}. ${item}`).join("\n");
  const value = window.prompt(`请选择操作:\n${promptText}`, "1");
  if (value == null) {
    if (typeof fail === "function") {
      fail({ errMsg: "showActionSheet:fail cancel" });
    }
    return;
  }
  const tapIndex = Number(value) - 1;
  if (Number.isNaN(tapIndex) || tapIndex < 0 || tapIndex >= itemList.length) {
    if (typeof fail === "function") {
      fail({ errMsg: "showActionSheet:fail invalid selection" });
    }
    return;
  }
  if (typeof success === "function") {
    success({ tapIndex });
  }
}

function chooseImage(options = {}) {
  const input = document.createElement("input");
  input.type = "file";
  input.accept = "image/*";
  if ((options.count || 1) > 1) {
    input.multiple = true;
  }
  input.style.display = "none";
  document.body.appendChild(input);
  input.addEventListener("change", () => {
    const files = Array.from(input.files || []);
    const tempFilePaths = files.map((file) => URL.createObjectURL(file));
    if (typeof options.success === "function") {
      options.success({
        tempFiles: files,
        tempFilePaths,
      });
    }
    input.remove();
  });
  input.click();
}

function uploadFile(options = {}) {
  const {
    url,
    filePath,
    name = "file",
    header = {},
    formData = {},
    success,
    fail,
  } = options;

  const form = new FormData();
  Object.entries(formData || {}).forEach(([key, value]) => {
    form.append(key, value);
  });
  form.append(name, filePath);

  fetch(url, {
    method: "POST",
    headers: header,
    body: form,
  })
    .then(async (response) => {
      const data = await response.text();
      if (typeof success === "function") {
        success({ data, statusCode: response.status });
      }
    })
    .catch((err) => {
      if (typeof fail === "function") {
        fail(err);
      }
    });
}

function requestPayment(options = {}) {
  showToast({ title: "浏览器环境跳过微信支付，已模拟支付成功", icon: "none", duration: 2400 });
  window.setTimeout(() => {
    if (typeof options.success === "function") {
      options.success({ errMsg: "requestPayment:ok" });
    }
  }, 300);
}

function login(options = {}) {
  if (typeof options.success === "function") {
    options.success({ code: "h5-local-login" });
  }
}

function navigateToMiniProgram(options = {}) {
  showToast({ title: "浏览器环境不支持小程序跳转", icon: "none" });
  if (typeof options.fail === "function") {
    options.fail({ errMsg: "navigateToMiniProgram:fail unsupported in h5" });
  }
}

function getUserProfile(options = {}) {
  if (typeof options.success === "function") {
    options.success({
      userInfo: {
        nickName: "H5用户",
        avatarUrl: "",
      },
      errMsg: "getUserProfile:ok",
      signature: "",
      encryptedData: "h5-encrypted-data",
      iv: "h5-iv",
    });
  }
}

function request(options = {}) {
  const {
    url = "",
    data = {},
    header = {},
    method = "GET",
    success,
    fail,
  } = options;

  let finalURL = url;
  const finalMethod = (method || "GET").toUpperCase();
  const finalHeaders = {
    "content-type": "application/json",
    ...header,
  };

  let body;
  if (finalMethod === "GET") {
    const query = new URLSearchParams();
    Object.entries(data || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        query.append(key, value);
      }
    });
    const queryString = query.toString();
    if (queryString) {
      finalURL += (finalURL.includes("?") ? "&" : "?") + queryString;
    }
  } else {
    body = JSON.stringify(data || {});
  }

  fetch(finalURL, {
    method: finalMethod,
    headers: finalHeaders,
    body,
  })
    .then(async (response) => {
      const payload = await response.json();
      if (typeof success === "function") {
        success({ data: payload, statusCode: response.status });
      }
    })
    .catch((err) => {
      if (typeof fail === "function") {
        fail(err);
      }
    });
}

export function ensureWxForH5() {
  if (typeof window === "undefined") {
    return;
  }
  if (typeof window.wx !== "undefined" && window.wx && window.wx.getSystemInfoSync) {
    return;
  }

  const storage = createStorage();
  window.wx = {
    __isH5Compat: true,
    getSystemInfoSync() {
      return {
        model: navigator.userAgent || "h5",
        platform: "h5",
        windowWidth: window.innerWidth || 375,
      };
    },
    setNavigationBarTitle({ title = "" } = {}) {
      document.title = title;
    },
    ...storage,
    showToast,
    showLoading,
    hideLoading,
    showModal,
    showActionSheet,
    stopPullDownRefresh() {},
    navigateBack() {
      window.history.back();
    },
    reLaunch({ url = "/" } = {}) {
      window.location.replace(url);
    },
    redirectTo({ url = "/" } = {}) {
      window.location.replace(url);
    },
    navigateTo({ url = "/" } = {}) {
      window.location.href = url;
    },
    chooseImage,
    uploadFile,
    requestPayment,
    request,
    login,
    navigateToMiniProgram,
    getUserProfile,
    getUpdateManager() {
      return {
        onCheckForUpdate() {},
        onUpdateReady() {},
        onUpdateFailed() {},
        applyUpdate() {},
      };
    },
  };
}
